/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectionGridExampublishid200,
  GetApiV1ExamCorrectionGridExampublishid400,
  GetApiV1ExamCorrectionGridExampublishid401,
  GetApiV1ExamCorrectionGridExampublishid500,
  GetApiV1ExamCorrectionGridExampublishidPathParams,
  GetApiV1ExamCorrectionGridExampublishidQueryParams,
  GetApiV1ExamCorrectionGridExampublishidQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGridExampublishid.ts";
import { examItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponseSchema } from "../examItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamCorrectionGridExampublishidPathParamsSchema = z.object(
  {
    examPublishId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishidPathParams>;

export const getApiV1ExamCorrectionGridExampublishidQueryParamsSchema =
  z.object({
    examItemId: z.optional(z.coerce.number().int()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(10),
  }) as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectionGridExampublishid200Schema = z.lazy(
  () =>
    examItemAnswerTextCorrectionSubGridItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectionGridExampublishid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectionGridExampublishid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectionGridExampublishid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishid500>;

export const getApiV1ExamCorrectionGridExampublishidQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamCorrectionGridExampublishid200Schema,
  ) as unknown as ToZod<GetApiV1ExamCorrectionGridExampublishidQueryResponse>;
